// ─── User Types ──────────────────────────────────────────────────────────────
// ─── API Response Envelope ───────────────────────────────────────────────────
export const API_ERROR_CODE = {
    SUCCESS: 0,
    UNKNOWN_ERROR: -2,
    PARAMETER_MISS_OR_VALUE_INVALID: -3,
    NO_SUCH_USER: -5,
    PASSWORD_ERROR: -6,
    TOKEN_ERROR: -7,
    PASSWORD_NOT_MATCH: -8,
    EMAIL_ALREADY_EXISTS: -9,
    PASSWORD_NOT_STRONG: -10,
    EMAIL_CODE_ERROR: -11,
    EMAIL_CODE_NOT_FOUND: -12,
    EMAIL_CODE_EXPIRED: -13,
    EMAIL_ALREADY_VERIFIED: -14,
    EMAIL_CODE_RATE_LIMITED: -15,
    TWO_FACTOR_REQUIRED: -16,
    TWO_FACTOR_INVALID: -17,
    TWO_FACTOR_ALREADY_ENABLED: -18,
    TWO_FACTOR_NOT_ENABLED: -19,
    CAPTCHA_REQUIRED: -20,
    CAPTCHA_NOT_FOUND: -21,
    CAPTCHA_EXPIRED: -22,
    CAPTCHA_INVALID: -23,
    ORDER_NOT_FOUND: -30,
    ORDER_HASBEEN_PAID: -32,
    ORDER_HASBEEN_EXPIRED: -33,
    USER_EMAIL_NOT_EXIST: -34,
    DATA_NOT_EXISTS: -40,
    BALANCE_INSUFFICIENT: -41,
    EMAIL_SEND_FAILED: -50,
    AUTHENTICATION_REQUIRED: -60,
    ADMIN_ACCESS_REQUIRED: -61,
    API_KEY_REQUIRED: -70,
    API_KEY_INVALID: -71,
    SERVICE_NOT_CONFIGURED: -80,
};
//# sourceMappingURL=index.js.map